export enum LanguageVersion {
  PL = 'pl'
}
